module.exports = __webpack_public_path__ + "static/img/adv-banner-hk.d5a636c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/adv-banner-hk.png
// module id = zhET
// module chunks = 1